import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { Subject } from 'rxjs'
import { debounceTime, switchMap } from 'rxjs/operators'
import { ContactsService } from '../../../api'
import { NotificationService } from '../../../common/layout/notification.service';
import { ContactsAppService } from '../contacts-app.service';

@Component({
    selector: 'ns-contacts-list',
    templateUrl: './contacts-list.component.html',
    styleUrls: ['./contacts-list.component.scss']
})
export class ContactsListComponent implements OnInit {

    items = [];
    groupedItems: {
        [key: string]: any[];
    }
    headers: string[]

    query = new FormControl('')

    constructor(
        private notificationService: NotificationService,
        private myDocumentsService: ContactsAppService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private contactsService: ContactsService,
    ) {
        this.items = activatedRoute.snapshot.data.items.data
        this.groupItems();
    }

    ngOnInit(): void {
        this.query.valueChanges.pipe(
          debounceTime(250),
          switchMap(query => {
              return this.contactsService.contactListQuery(null, null, query)
          }),
        ).subscribe(res => {
            this.items = res.data;
            this.groupItems();
        })
    }

    groupItems(): void{
        this.headers  = [];
        this.groupedItems = {}
        this.items.forEach(item => {
            const lastNameFirstLetter = item.lastName.slice(0, 1).toUpperCase()
            if (!this.headers.includes(lastNameFirstLetter)) {
                this.headers.push(lastNameFirstLetter)
            }
            if (!this.groupedItems[lastNameFirstLetter]) {
                this.groupedItems[lastNameFirstLetter] = []
            }
            this.groupedItems[lastNameFirstLetter].push(item)
        })
    }

    public removeItem(item) {
        if (item) {
            this.notificationService.confirm(() => {
                this.myDocumentsService.deleteContact(item.id).then(
                    () => {
                        this.items.splice(this.items.indexOf(item), 1);
                        this.groupItems();
                    }
                );

            }, {
                title: 'Potwierdzenie',
                content: 'Czy na pewno usunać wybrany element?',
                width: 0
            });
        }
    }

    public getDate(val: string) {
        let tmp = val.substring(0, val.indexOf(' '));
        let arr = tmp.split('-')
        return arr[2] + '.' + arr[1] + '.' + arr[0];
    }

    navigateToForm(): void {
        this.router.navigate(['dodaj'], { relativeTo: this.activatedRoute })
    }

    navigateToEditForm(id): void {
        this.router.navigate([id], { relativeTo: this.activatedRoute })
    }

}
